import React, { useEffect } from 'react'

import useEmblaCarousel from 'embla-carousel-react'
import { Container } from 'react-bootstrap'



function SliderV3(sliders) {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false })

    useEffect(() => {
      if (emblaApi) {
        console.log(emblaApi.slideNodes()) // Access API
      }
    }, [emblaApi])
  
  return (
    <Container style={{marginTop:10}}>
    <div className="embla" ref={emblaRef}>
      <div className="embla__container">
        <div className="embla__slide">Slide 1</div>
        <div className="embla__slide">Slide 2</div>
        <div className="embla__slide">Slide 3</div>
      </div>
    </div>
    </Container>
  )
}

export default SliderV3